// API Configuration - Environment-based
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://irsaudit-production.up.railway.app/';
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'production';

// Log configuration for debugging
if (ENVIRONMENT === 'development') {
  console.log('🔧 Frontend Configuration:');
  console.log(`   Environment: ${ENVIRONMENT}`);
  console.log(`   API Base URL: ${API_BASE_URL}`);
}

// Other configuration constants can be added here
export const MAX_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB
export { API_BASE_URL, ENVIRONMENT }; 